import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  ButtonBase,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import Dialog from "components/NoScrollDialog";
import { useMemo, useState } from "react";

export default function Attachment({
  attachment,
  onRemoveAttachment,
  readOnly,
  lazy = false,
  reason,
}) {
  const [loaded, setLoaded] = useState(false);
  const [open, setOpen] = useState(false);

  const src = useMemo(() => {
    if (!attachment) return;

    if (typeof attachment.url === "string") {
      return attachment.url;
    } else if (attachment.url instanceof File) {
      const objectUrl = URL.createObjectURL(attachment.url);
      return objectUrl;
    }
  }, [attachment?.url]);

  return (
    <>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            m: 0,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          Attachment
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 2,
          }}
        >
          <img
            src={src}
            alt="Attachment"
            style={{
              maxWidth: "100%",
              maxHeight: "70vh",
              borderRadius: 8,
            }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)} variant="text" color="info">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <ButtonBase
        onClick={() => {
          setOpen(true);
        }}
        sx={(theme) => ({
          height: "80px",
          width: "80px",
          overflow: "hidden",
          borderRadius: "8px",
          border: "1px solid " + theme.palette.divider,
          position: "relative",
        })}
      >
        {!loaded && !lazy ? (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <CircularProgress size={20} color="info" />
          </Box>
        ) : readOnly ? (
          ""
        ) : (
          <Tooltip title={!onRemoveAttachment ? reason?.disabledRemove : ""}>
            <Box
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                backgroundColor: "red",
                borderRadius: "2px",
                opacity: !onRemoveAttachment ? 0.5 : 1,
              }}
            >
              <IconButton
                disabled={!onRemoveAttachment}
                size="small"
                sx={{
                  width: "20px",
                  height: "20px",
                  ":disabled": {
                    opacity: 0.8,
                  },
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  onRemoveAttachment(attachment);
                }}
              >
                <Close color="white" />
              </IconButton>
            </Box>
          </Tooltip>
        )}

        <img
          src={src}
          alt=""
          loading={lazy ? "lazy" : undefined}
          decoding={lazy ? "async" : undefined}
          style={{
            height: "100px",
            width: "100px",
            objectFit: "cover",
            display: loaded || lazy ? "block" : "none",
          }}
          onLoad={() => setLoaded(true)}
        />
      </ButtonBase>
    </>
  );
}
